import { type ComponentType, type LazyExoticComponent, lazy } from "react";

/**
 * Registro de apps core (F0-T07). Estático en F0; el shape es deliberadamente
 * compatible con ModuleManifest (os §3: id, app lazy, icon, artifactTypes) para
 * que el framework de módulos de F1-T07 lo absorba sin tocar consumidores.
 */

export interface AppDef {
  id: string;
  title: string;
  /** Glifo placeholder — iconografía real del OS en F4 (atlas) */
  glyph: string;
  component: LazyExoticComponent<ComponentType>;
  defaultSize: { w: number; h: number };
}

export const APP_REGISTRY: readonly AppDef[] = [
  {
    id: "briefing",
    title: "Briefing",
    glyph: "✉",
    component: lazy(() => import("./briefing/BriefingApp")),
    defaultSize: { w: 560, h: 480 },
  },
  {
    id: "chirp",
    title: "Chirp",
    glyph: "◗",
    component: lazy(() => import("./chirp/ChirpApp")),
    defaultSize: { w: 520, h: 560 },
  },
  {
    id: "mail",
    title: "Mail",
    glyph: "▤",
    component: lazy(() => import("./mail/MailApp")),
    defaultSize: { w: 640, h: 500 },
  },
  {
    id: "archivo",
    title: "Archivo",
    glyph: "▦",
    component: lazy(() => import("./archivo/ArchivoApp")),
    defaultSize: { w: 600, h: 480 },
  },
  {
    id: "visor",
    title: "Visor",
    glyph: "◉",
    component: lazy(() => import("./visor/VisorApp")),
    defaultSize: { w: 640, h: 520 },
  },
  {
    id: "messenger",
    title: "Messenger",
    glyph: "◍",
    component: lazy(() => import("./messenger/MessengerApp")),
    defaultSize: { w: 420, h: 520 },
  },
  {
    id: "corcho",
    title: "Corcho",
    glyph: "✕",
    component: lazy(() => import("./corcho/CorchoApp")),
    defaultSize: { w: 720, h: 560 },
  },
  {
    id: "acusacion",
    title: "Acusación",
    glyph: "§",
    component: lazy(() => import("./acusacion/AcusacionApp")),
    defaultSize: { w: 520, h: 560 },
  },
  {
    id: "ajustes",
    title: "Ajustes",
    glyph: "❖",
    component: lazy(() => import("./ajustes/AjustesApp")),
    defaultSize: { w: 480, h: 420 },
  },
];

const byId = new Map(APP_REGISTRY.map((a) => [a.id, a]));

export function getApp(id: string): AppDef | undefined {
  return byId.get(id);
}
